<template>
    <div class="row">
        <div class="col-md-12">
            <div class="admin-form theme-primary tab-pane active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            Добавить группу
                        </span>
                    </div>
                    <form @submit.prevent="save">
                        <div class="panel-body p25">
                            <div class="section row">
                                <div class="col-md-12">

                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="set" v-model="$v.group.isStarted.$model" value="0">
                                        <label for="set" data-on="Да" data-off="Нет"></label>
                                        <span>Скоро старт</span>
                                    </label>
                                    <div v-if="$v.group.isStarted.$error === true || forms.group.errors.is_started" class="error">
                                        {{ this.forms.group.errors.is_started ? this.forms.group.errors.is_started.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-3">
                                    <label class="field-label">Филиал</label>
                                    <label class="field select">
                                        <select v-model="$v.group.filiationId.$model">
                                            <option disabled="">Выберите филиал</option>
                                            <option
                                                    v-for="filiation in data.filiations"
                                                    v-bind:key="filiation.id"
                                                    :value="filiation.id"
                                            >
                                                {{filiation.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.group.filiationId.$error === true || forms.group.errors.filiation_id" class="error">
                                        {{ this.forms.group.errors.filiation_id ? this.forms.group.errors.filiation_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label for="course" class="field-label">Направление</label>
                                    <label class="field select">
                                        <select id="course" name="course" v-model="$v.group.directionId.$model">
                                            <option disabled="">Выберите направление</option>
                                            <option
                                                    v-for="direction in data.directions"
                                                    v-bind:key="direction.id"
                                                    :value="direction.id"
                                            >
                                                {{direction.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.group.directionId.$error === true || forms.group.errors.direction_id" class="error">
                                        {{ this.forms.group.errors.direction_id ? this.forms.group.errors.direction_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="instructor" class="field-label">Преподаватель</label>
                                    <label class="field select">
                                        <select id="instructor" name="instructor" v-model="$v.group.trainerId.$model">
                                            <option disabled="">Выберите преподавателя</option>
                                            <option
                                                    v-for="trainer in data.trainers"
                                                    v-bind:key="trainer.id"
                                                    :value="trainer.id"
                                            >
                                                {{trainer.fullName}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.group.trainerId.$error === true || forms.group.errors.trainer_id" class="error">
                                        {{ this.forms.group.errors.trainer_id ? this.forms.group.errors.trainer_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <label for="levels" class="field-label">Сложность</label>
                                    <label class="field select">
                                        <select id="levels" name="level" v-model="$v.group.difficultyId.$model">
                                            <option disabled="">Выберите сложность</option>
                                            <option
                                                    v-for="difficulty in data.difficulties"
                                                    v-bind:key="difficulty.id"
                                                    :value="difficulty.id"
                                            >
                                                {{difficulty.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.group.difficultyId.$error === true || forms.group.errors.difficulty_id" class="error">
                                        {{ this.forms.group.errors.difficulty_id ? this.forms.group.errors.difficulty_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>


                                <!-- end section -->
                            </div>

                            <!-- end section -->
                            <div class="section row dayrow" v-for="day in group.days" v-bind:key="day.dayOfWeek">
                                <div class="col-md-2">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" name="day" class="day" :id="`day-status-${day.dayOfWeek}`" v-model="day.status">
                                        <label :for="`day-status-${day.dayOfWeek}`" data-on="|" data-off="o"></label>
                                        <span>{{day.getWeekName()}}</span>
                                    </label>
                                </div>
                                <div class="col-md-3">
                                    <label class="field prepend-icon">
                                        <input type="text" name="start_time" class="gui-input " v-model="day.start" :disabled="day.status === false">
                                        <b class="tooltip  tip-right-top">
                                            <em>
                                                <i>Время начала.</i><br>
                                                <b>Например: 10:00</b>
                                            </em>
                                        </b>
                                        <label class="field-icon">
                                            <i class="fa fa-clock-o"></i>
                                        </label>
                                    </label>
                                </div>
                                <div class="col-md-3">
                                    <label class="field prepend-icon">
                                        <input type="text" name="end_time" class="gui-input " v-model="day.end" :disabled="day.status === false">
                                        <b class="tooltip  tip-right-top">
                                            <em>
                                                <i>Время окончания.</i><br>
                                                <b>Например: 10:00</b>
                                            </em>
                                        </b>

                                        <label class="field-icon">
                                            <i class="fa fa-clock-o"></i>
                                        </label>
                                    </label>
                                </div>
                                <div class="col-md-4">
                                    <label class="field select">
                                        <select class="day1" name="room" v-model="day.fitnessRoomId" :disabled="day.status === false">
                                            <option disabled="">Выберите зал</option>
                                            <option
                                                    v-for="fitnessRoom in data.fitnessRooms.filter(room => room.filiationId === group.filiationId)"
                                                    v-bind:key="fitnessRoom.id"
                                                    :value="fitnessRoom.id"
                                            >
                                                {{fitnessRoom.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                </div>
                            </div>

                            <!-- end section -->
                            <div class="section row">
                                <div class="col-md-6">
                                    <label for="start_period" class="field-label">Начало периода</label>
                                    <label class="field prepend-icon">
                                        <input type="date" name="start_period" id="start_period"
                                               v-model="$v.group.start.$model"
                                               class="gui-input" value="">
                                        <label for="start_period" class="field-icon">
                                            <i class="fa fa-calendar"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.group.start.$error === true || forms.group.errors.start" class="error">
                                        {{ this.forms.group.errors.start ? this.forms.group.errors.start.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="end_period" class="field-label">Окончание периода</label>
                                    <label class="field prepend-icon">
                                        <input type="date" name="end_period" id="end_period" class="gui-input"
                                               v-model="$v.group.end.$model"
                                               value="">
                                        <label for="end_period" class="field-icon">
                                            <i class="fa fa-calendar"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.group.end.$error === true || forms.group.errors.end" class="error">
                                        {{ this.forms.group.errors.end ? this.forms.group.errors.end.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.group.comment.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>

                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary">
                                Добавить
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
        </div>
    </div>
</template>

<script>
    import Group from "../../../models/Group";
    import GroupDay from "../../../models/GroupDay";
    import Direction from "../../../models/v2/Direction";
    import Trainer from "../../../models/v2/Trainer";
    import FitnessRoom from "../../../models/FitnessRoom";
    import {validationMixin} from 'vuelidate';
    import Filiation from "../../../models/Filliation";
    import moment from 'moment';

    export default {
        async beforeRouteEnter(to, from, next) {

            let roomsResponse, directionsResponse, trainersResponse, filiationsResponse;
            [roomsResponse, directionsResponse, trainersResponse, filiationsResponse] = await Promise.all([
                FitnessRoom.getList(1, 999),
                Direction.getList({}, 1, 'name', -1),
                Trainer.getList({}, 1, 'first_name,last_name', -1),
                Filiation.getList(1, 999),
            ]);
            next(component => {

                component.data.directions = directionsResponse.data;
                component.data.trainers = trainersResponse.data;
                component.data.fitnessRooms = roomsResponse.data;
                component.data.filiations = filiationsResponse.data;
                for (let day = 0; day < 7; day++) {
                    component.$set(component.group.days, day, new GroupDay({
                        status: false,
                        dayOfWeek: day + 1,
                        start: '',
                        end: '',
                        fitnessRoomId: null,
                    }));
                }
            });
        },
        mixins: [validationMixin],
        data() {
            return {
                isLoading: false,
                data: {
                    filiations: [],
                    directions: [],
                    trainers: [],
                    fitnessRooms: [],
                    difficulties: [
                        {
                            id: 1,
                            name: 'Начинающий',
                        },
                        {
                            id: 2,
                            name: 'Продвинутый',
                        },
                    ],
                },
                group: new Group({
                    days: [],
                    start: moment().format('YYYY-MM-DD'),
                    end: moment().add(30, 'year').format('YYYY-MM-DD'),
                    status: false,
                }),
                forms: {
                    group: {
                        isSubmitting: false,
                        errors: {},
                        password: '',
                    },
                },
            };
        },
        validations: {
            group: {
                filiationId: {},
                isStarted: {},
                directionId: {},
                trainerId: {},
                difficultyId: {},
                capacity: {},
                start: {},
                end: {},
                comment: {},
            },
        },
        methods: {

            async save() {
                this.$v.group.$touch();
                if (this.$v.group.$invalid) {
                    return false;
                }

                this.isLoading = true;

                this.forms.group.isSubmitting = true;
                this.forms.group.errors = {};

                try {
                    const group = await this.group.add();

                    await this.$router.push({name: 'schedule-group-edit', params: {id: group.id}});
                } catch (error) {
                    this.forms.group.errors = error.errors;
                }


                this.isLoading = false;
                this.forms.group.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Группы - добавление',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
